module.exports = __webpack_public_path__ + "static/media/comparador2.84815586.png";